import * as React from 'react';
import { useSelector } from 'react-redux';

import { AboutRealtorDesktopContainer } from '../AboutRealtorContainer';
import { selectCurrentRealtor } from '../../selectors/selectCurrentRealtor';
import { realtorInfoApi } from '../../api/realtorInfoApi';
import { ISpecialistCatalogListingSchema } from '../../repositories/demand/entities/specialist_catalog/SpecialistCatalogListingSchema';

export function RealtorInfoDesktopContainer() {
  // NOTE: мы не отрисывываем парента, если этих данных нет
  const realtor = useSelector(selectCurrentRealtor) as ISpecialistCatalogListingSchema;
  const getRealtorInfoState = realtorInfoApi.endpoints.getRealtorInfo.useQueryState({
    cianUserId: realtor.cianUserId,
  });

  if (!getRealtorInfoState?.data || !realtor) {
    return null;
  }

  return <AboutRealtorDesktopContainer realtorCardData={getRealtorInfoState.data} realtor={realtor} />;
}
